/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useState, useRef, useEffect } from 'react'
import { useParams, useLocation, Link } from "react-router-dom";
import { XIcon } from '@heroicons/react/outline'
import { MailIcon, PhoneIcon, StarIcon } from '@heroicons/react/solid'
import { Dialog, RadioGroup, Transition } from '@headlessui/react'
import slugify from 'slugify';

import Cta from "../../components/Cta"
import ReadMore from "../../components/ReadMore"
import DealCard from './DealCard'
import DealQuickView from './DealQuickview'
import DealService from '../../services/DealService'
import { DealProvider, DealContext, useDeal } from '../../providers/DealProvider';
import { UserProvider, useUser } from '../../providers/UserProvider';
import NoResultsImage from "../../../images/search-no-results-image.png";

const colors = [
    { name: 'Black', bgColor: 'bg-gray-900', selectedColor: 'ring-gray-900' },
    { name: 'Heather Grey', bgColor: 'bg-gray-400', selectedColor: 'ring-gray-400' },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const Seperator = () => {
  return (
    <div className="w-full border-t border-gray-300" />
  )
}

const CodeCopy = (props) => {
  const [copied, setCopied] = useState("Copy");
  let deal = props.deal;
  const copyCodeToClipboard = (evt) => {
    let code = props.deal.redemption_code;
    navigator.clipboard.writeText(code).then(() => {
      setCopied('Copied');

    }, (err) => {
      console.error("Failed to copy Text.");
      setCopied('Error');
    });

  }

  useEffect(() => {
    setCopied("Copy");
  }, [props.deal.redemption_code]);

  return (
      <div id="clipboard_btn" className="cursor-pointer inline-block text-body-2 bg-grey-codeCopy py-2 px-4 rounded-full" onClick={copyCodeToClipboard}>
        <div className="">
          { props.deal.redemption_code }
          <span className="bg-blue-700 text-white rounded-full ml-3 px-2.5 py-0.5 inline">
            {copied}
          </span>
        </div>
      </div>
  )
}

const LinkRedeem = (props) => {
  const deal = props.deal;
  let currentStyle = 'inline-flex w-full items-center justify-center px-14 py-4 border border-blue-700 font-cta-label text-body-1-md rounded-full text-black bg-white hover:text-white hover:bg-blue-700';

  const [user, userDispatch] = useUser();

  return (
    <>
      {user.loggedIn &&
        <>
        <h3 className="font-secondary font-weight-700 text-headline-5">How to Redeem</h3> 
        <p><span className="font-primary text-body-2 p-2 rounded-[3px] bg-convoy-deal-type">Link</span></p>
        <p className="text-grey-lighter text-body-2">
          <ReadMore>
            {deal.desc}
          </ReadMore>
        </p>
  
        <Seperator />
  
        <div className="mb-4">
          <a id="redeem_btn" target="_blank" href={deal.redemption_url} className={currentStyle}>Redeem</a>
        </div>
        </>
      }

      {!user.loggedIn &&
        <>
        <h3 className="font-secondary font-weight-700 text-headline-5">How to Redeem</h3> 
        <p><span className="font-primary text-body-2 p-2 bg-convoy-deal-type">Link</span></p>
        <p className="blur-sm text-grey-lighter text-body-2">
          <div className="transition ease-in-out delay-150">
            <p>Get a 30-day free trial when you sign up through The Convoy using the link provided.</p>
            <p>Offer Details:  Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing ...</p>
            <p className="mt-2 underline">
              Read More
            </p>
          </div>
        </p>
  
        <Seperator />
  
        <div className="mb-4 space-y-4">
          <p className="font-primary text-body-2 text-center">Get this and 150+ offers when you sign up through The Convoy.</p>
          <a href="/register" className='inline-flex w-full items-center justify-center px-14 py-4 font-cta-label text-white text-body-1-md rounded-full bg-blue-500 hover:bg-blue-400'>Sign Up</a>
        </div>
        </>
      }
    </>
  )
}

const CodeRedeem = (props) => {
  const deal = props.deal;
  let currentStyle = 'inline-flex w-full items-center justify-center px-14 py-4 border border-blue-700 font-cta-label text-body-1-md rounded-full text-black bg-white hover:text-white hover:bg-blue-700';

  const [user, userDispatch] = useUser();

  return (
    <>
      {user.loggedIn &&
        <>
          <h3 className="font-secondary font-weight-700 text-headline-5">How to Redeem</h3> 
          <p><span className="font-primary text-body-2 p-2 rounded-[3px] bg-convoy-codeCopy">Code</span></p>
          <p className="text-grey-lighter text-body-2">
            <ReadMore>
              {deal.desc}
            </ReadMore>
          </p>
          <div className="">
            <CodeCopy deal={deal} />
          </div>
    
          <Seperator />
    
          <div className="mb-4">
            <a id="redeem_btn" target="_blank" href={deal.redemption_url} className={currentStyle}>Redeem</a>
          </div>
        </>
      }

      {!user.loggedIn &&
        <>
          <h3 className="font-secondary font-weight-700 text-headline-5">How to Redeem</h3> 
          <p><span className="font-primary text-body-2 p-2 bg-convoy-codeCopy">Code</span></p>
          <p className="blur-sm text-grey-lighter text-body-2">
            <div className="transition ease-in-out delay-150">
              <p>Get a 30-day free trial when you sign up through The Convoy using the link provided.</p>
              <p>Offer Details:  Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing ...</p>
              <p className="mt-2 underline">
                Read More
              </p>
            </div>
          </p>
          <div className="blur-sm">
            <span className="text-body-2 bg-grey-codeCopy py-2 px-4 rounded-full w-[120px] flex flex-cols justify-center">
              <div className="">CODE</div> 
              <div className="bg-blue-700 text-white rounded-full ml-4 px-2">
                Copy
              </div>
            </span>
          </div>
    
          <Seperator />

          <div className="mb-4 space-y-4">
            <p className="font-primary text-body-2 text-center">Get this and 150+ offers when you sign up through The Convoy.</p>
            <a href="/register" className='inline-flex w-full items-center justify-center px-14 py-4 font-cta-label text-white text-body-1-md rounded-full bg-blue-500 hover:bg-blue-400'>Sign Up</a>
          </div>
        </>
      }
    </>
  )
}

function DealGrid(props) {
  let products = props.deals;
  let currentStyle = 'inline-flex w-full items-center justify-center px-14 py-4 border border-blue-700 font-cta-label text-body-1-md rounded-full text-black bg-white hover:text-white hover:bg-blue-700';
  let logoClass = `w-32 h-32 p-2 flex justify-center rounded-2xl group-hover:opacity-75`;
  const dialogRef = useRef(null);

  const [openQuickView, setOpenQuickView] = useState(false);
  const [product, setProduct] = useState({
    vendor: {}
  });

  const [selectedColor, setSelectedColor] = useState(colors[0]);

  const [state, dispatch] = useDeal()
  const [user, userDispatch] = useUser();

  const { dealId } = useParams();
  const location = useLocation();

  const isSearchResults = (location.pathname == '/marketplace/search');
  const queryParams = location.search.split('=');
  const query = (queryParams.length > 1) ? queryParams[1] : null;

  const sample = (arr) => {
    let idx = Math.floor(Math.random() * arr.length-4);
    return arr.slice(idx, idx+4);
  }

  const openDeal = async (dealId) => {

    // Add error handling to activeDeal is not null.
    try {
      const response = await DealService.getDeal(dealId);
      console.log(response);
      let payload = response.data.data;
      let errors = response.data.errors;

      if (errors) {
        return;
      }
      
      let idx = Math.floor(Math.random() * payload.deals.length - 4);
      let deal = payload.deal;

      if (deal && deal.category) {
        deal.category = deal.category.map((category) => {
          let display = payload.dealCategories.filter((cat) => {
            return cat.key == category;
          });
          return display.pop();
        }).filter(x => x);
      }

      dispatch({ type: "quickview/open", payload: { deal: deal, relatedDeals: deal.similarDeals } });
    } catch (error) {
      console.error(error.message);
    }
  }

  const openRelatedDeal = (deal) => {
    let idx = Math.floor(Math.random() * state.deals.length-4);

    deal.category = deal.category.map((category) => {
      let display = state.categories.filter((cat) => {
        return cat.key == category;
      });
      return display.pop();
    }).filter(x => x);

    dispatch({ type: "quickview/open", payload: { deal:deal, relatedDeals: deal.similarDeals } });
    dialogRef.current.scrollIntoView();
  }

  useEffect(() => {
    if (dealId) {
      openDeal(dealId);
    }
  }, []);

  return (
    <section aria-labelledby="product-heading" className="mt-6 lg:mt-0 lg:col-span-2 xl:col-span-3">
      {/* Get search params and show results lang */}
      {!isSearchResults && !state.loadingAllDeals && <h2 id="product-heading" className="text-center mt-4 xl:mt-0 xl:text-left xl:block font-header text-headline-4">
        { (state.category.name) ? `${state.category.name} Offers` : "" } 
      </h2>}
      {isSearchResults && !state.loadingAllDeals && <h2 id="product-heading" className="text-center mt-4 xl:mt-0 xl:text-left xl:block font-header text-headline-4">
        {state.deals.length} results for “{query}”
      </h2>}
      <div className="grid grid-cols-1 gap-y-8 lg:grid-cols-2 lg:gap-x-6 lg:gap-y-10 xl:grid-cols-3 mt-4">
        {!state.loadingAllDeals && state.deals && state.deals.map((deal) => (
          <Link key={deal.id} to={`/marketplace/${slugify(deal.vendor.name, {lower: true})}/${slugify(deal.name, {lower: true})}/${deal.id}`}>
            <DealCard 
              deal={deal}
              key={deal.id}
              setOpenQuickView={setOpenQuickView}
              setProduct={setProduct}
            />
          </Link>
        ))}
        {state.deals && state.deals.length === 0 && !state.loadingAllDeals && <div className="col-span-3" style={{
          // height: '476px',
          borderRadius: '3px',
          backgroundColor: 'rgba(229, 241, 255, 1)',
          border: '1px solid rgba(237, 237, 237, 1)',
        }}>
          <h2 className="text-center mt-20 mb-2 text-headline-2 font-secondary">Oops!</h2>
          <p style={{color: '#111827'}} className="text-center text-body-1-md font-primary mb-12">Hmm… no results here. Try searching for something else.</p>
          <img
            className="h-auto w-auto object-cover mx-auto mb-14"
            src={NoResultsImage}
            alt="No results"
          />
        </div>}
      </div>

    {/* Product Popup */}
    <Transition.Root show={state.quickViewOpen} as={Fragment}>
      <Dialog as="div" className="fixed z-55 inset-0 overflow-y-auto" onClose={() => {dispatch({ type: "quickview/close" }) }}>
        <div ref={dialogRef} className="flex min-h-screen text-center md:block md:px-2 lg:px-4" style={{ fontSize: 0 }}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="hidden fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity md:block" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span className="hidden md:inline-block md:align-middle md:h-screen" aria-hidden="true">
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 md:translate-y-0 md:scale-95"
            enterTo="opacity-100 translate-y-0 md:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 md:scale-100"
            leaveTo="opacity-0 translate-y-4 md:translate-y-0 md:scale-95"
          >
            <div className="flex text-base text-left transform transition w-deal-modal md:inline-block md:w-deal-modal-md md:px-4 md:my-8 md:align-middle xl:w-deal-modal-xl">
              <div className="w-full rounded-2xl relative flex flex-col space-y-4 bg-white px-4 pt-14 pb-8 overflow-hidden shadow-2xl sm:px-6 sm:pt-8 md:p-6 lg:p-8">
                {/* Close Button  */}
                <button
                  type="button"
                  className="absolute p-2 round-md top-4 right-4 hover:text-gray-500 top-6 right-6"
                  onClick={() => { dispatch({ type: "quickview/close" }) }}
                  >
                    <span className="sr-only">Close</span>
                    <XIcon className="h-4 w-4" aria-hidden="true" />
                </button>

                {/* <div className="grid grid-cols-1 xl:grid-cols-3 justify-items-center xl:justify-items-start"> */}
                <div className="flex flex-col xl:flex-row xl:space-x-4 items-center">
                  {/* Image  */}
                  <div 
                    className="w-32 h-32 flex flex-shrink-0 justify-center rounded-2xl group-hover:opacity-75"
                    style={{backgroundColor: `#${state.activeDeal.logoColor || 'fff'}`}}
                  >
                    <img
                      src={state.activeDeal.vendor.image}
                      alt={state.activeDeal.imageAlt}
                      className="object-center object-contain"
                    />
                  </div> 

                  <div className="mt-4 font-primary text-center xl:text-left">
                    <h4 className="font-secondary text-subtitle text-gray-900">{state.activeDeal.vendor.name}</h4>
                    <h3 classname="">{state.activeDeal.name}</h3>
                    <p className="font-subtitle text-deal-card-terms text-grey-light font-primary my-4 xl:my-0.5">
                      { state.activeDeal.category ? state.activeDeal.category.map((cat) => { return cat.name  } ).join(" | ") : "" }
                    </p>
                    <p className="font-subtitle text-deal-card-terms text-grey-light font-primary my-4 xl:my-0.5">{state.activeDeal.shortDesc}</p>
                  </div>

                  <div className="flex flex-row items-center justify-center bg-white w-full xl:w-auto xl:min-w-[240px] py-4 text-center border-2 border-convoy-aqua rounded-2xl group-hover:outline-card">
                    <div className="font-secondary font-weight-700 text-convoy-aqua text-headline-3 uppercase mr-2">{state.activeDeal.averageSavings}</div>
                    <div className="font-secondary font-weight-700 text-overline uppercase">Average Savings</div>
                  </div>
                </div>

                <Seperator />

                <div className="grid grid-cols-1 xl:grid-cols-2 xl:space-x-6">
                  <div className="font-primary detail-left-col">
                    <div className="space-y-4">
                      {/* Link Redemption  */}
                      { (state.activeDeal.redemption_type == 'Link') &&
                          <LinkRedeem deal={state.activeDeal} />
                      }

                      {/* Code Redemption  */}
                      { (state.activeDeal.redemption_type == 'Code') &&
                          <CodeRedeem deal={state.activeDeal} />
                      }
                    </div>

                    <div className="my-4"><Seperator /></div>

                    <div className="space-y-4">
                      <h3 className="font-secondary font-weight-700 text-headline-5">About the Company</h3> 
                      <p className="text-grey-lighter text-body-2">
                        <ReadMore>
                          {state.activeDeal.vendor.desc}
                        </ReadMore>
                      </p>
                    </div>

                    <div className="my-4"><Seperator /></div>

                    <div className="space-y-4">
                      <h3 className="font-secondary font-weight-700 text-headline-5">Terms & Conditions</h3> 
                      <p className="text-grey-lighter text-body-2">{state.activeDeal.terms}</p>
                    </div>

                    <div className="xl:hidden my-4"><Seperator /></div>
                  </div>

                  {/* Similar Offers */}
                  <div className="detail-right-col">
                    <h3 className="font-secondary font-weight-700 text-headline-5">Similar Offers</h3>
                    <div className="mt-4 flex flex-col">
                      { state.relatedDeals.map((deal) => (
                        <div 
                          key={deal.id}
                          className="bg-grey-featured rounded-xl cursor-pointer flex flex-row truncate px-4 mb-4 items-center justify-left"
                          onClick={ () => {openRelatedDeal(deal); } }
                        >
                          <div 
                            className="w-20 h-20 flex-shrink-0 flex justify-center border my-4 mr-4 p-2"
                            style={{backgroundColor: `#${deal.logoColor || 'fff'}`}}
                          >
                            <img 
                              src={deal.vendor.image || ""}
                              className="object-center object-contain"
                              alt={deal.imageAlt}
                            />
                          </div>
                          <div className="truncate flex-shrink lg:max-w-xl">
                            <div className="font-secondary font-bold text-headline-5">{deal.vendor.name}: {deal.name}</div>
                            <div className="truncate font-subtitle text-body-2">{deal.shortDesc}</div>
                          </div>
                        </div>
                      ) ) }
                    </div>
                  </div>
                </div>

                {/* Close Button */}
                <div className="hidden mt-4 grid grid-cols-1 xl:grid-cols-2 font-primary">
                    <h3 className="font-secondary text-subtitle text-gray-900">
                      {state.activeDeal.vendor.name}: {state.activeDeal.name}
                    </h3>
                    <p className="font-subtitle text-deal-card-terms text-grey-light font-primary my-4">{state.activeDeal.value}</p>

                    <Seperator />

                    <h3 className="mt-4 font-subtitle text-subtitle text-black">
                      Offer Details
                    </h3>
                    <p className="text-deal-card-desc text-grey-light my-4">{state.activeDeal.desc}</p>

                    <div className="inline-flex mb-4">
                      <a target="_blank" href={state.activeDeal.redemption_url} className={currentStyle}>Learn More & Redeem</a>
                    </div>

                    <Seperator />

                    <h3 className="mt-4 font-subtitle text-subtitle text-black">
                      Terms & Conditions
                    </h3>
                    <p className="text-deal-card-desc text-grey-light my-4">{state.activeDeal.terms}</p>

                    <Seperator />

                    <h3 className="mt-4 font-subtitle text-subtitle text-black">
                      About the Company
                    </h3>
                    <p className="text-deal-card-desc text-grey-light mb-8 mt-4">{state.activeDeal.vendor.desc}</p>

                    <Seperator />

                    {/* Similar Offers */}
                    <h3 className="mt-4 font-subtitle text-subtitle text-black">
                      Similar Offers
                    </h3>
                    <div className="mt-4 flex flex-col">
                      { state.relatedDeals.map((deal) => (
                        <div 
                          className="cursor-pointer flex flex-row truncate lg:pl-4 mb-4 items-center justify-left"
                          onClick={ () => {openRelatedDeal(deal); } }
                        >
                          <div 
                            className="w-16 h-16 flex-shrink-0 flex justify-center border mr-4 p-2"
                            style={{backgroundColor: `#${deal.logoColor || 'fff'}`}}
                          >
                            <img 
                              src={deal.vendor.image || ""}
                              className="object-center object-contain"
                              alt={deal.imageAlt}
                            />
                          </div>
                          <div className="truncate flex-shrink lg:max-w-xl">
                            <div className="font-secondary font-bold text-black">{deal.vendor.name}: {deal.name}</div>
                            <div className="hidden truncate font-subtitle text-black">{deal.desc}</div>
                          </div>
                        </div>
                      ) ) }
                    </div>

                </div>                 
              </div>
            </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </section>
  )
}

export default DealGrid;
